// extracted by mini-css-extract-plugin
export default {"modulesScrollbarWrapper":"_31h0j","scrollbarWrapper":"_1_Mc8"};